export default "/season1.8e7b6ef8ba6466c8deae1e90de032b12.png";